import { logger } from './utils/logger';

// API Configuration
// Load API URL from environment variable or use default
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Log the API URL being used
logger.info('config', 'API configuration loaded', { API_BASE_URL });
// API_BASE_URL loaded for configuration

// OIDC configuration for frontend redirect URI (Keycloak will redirect back here).
export const OIDC_REDIRECT_URI =
  process.env.REACT_APP_OIDC_REDIRECT_URI || `${window.location.origin}/v1/auth/callback`;

export const OIDC_POST_LOGOUT_REDIRECT_URI =
  process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/`;

// Authentication settings
export const TOKEN_STORAGE_KEY = 'autobot_auth_token';
export const USER_STORAGE_KEY = 'autobot_user';

// Application settings
export const APP_NAME = 'Autobot Competency Analyzer';
export const APP_VERSION = '1.0.0';

// Default pagination settings
export const DEFAULT_PAGE_SIZE = 10;

// File upload settings
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_FILE_TYPES = ['application/pdf', 'text/plain'];
